import { ApiUserQuota } from 'sprites-types/api/user-quota'

export const hasEnoughEditCredits = (userQuota: ApiUserQuota | undefined): boolean => {
  if (!userQuota) {
    return false
  }

  return userQuota.editCredits === 'unlimited' || userQuota.editCredits > 0
}

export const hasEnoughAppCount = (userQuota: ApiUserQuota | undefined): boolean => {
  if (!userQuota) {
    return false
  }
  return (
    userQuota.subscription.maxApps === 'unlimited' ||
    userQuota.subscription.maxApps > userQuota.appCount
  )
}

export const hasNegativeAppCount = (userQuota: ApiUserQuota | undefined): boolean => {
  if (!userQuota) {
    return false
  }

  return userQuota.subscription.maxApps !== 'unlimited' && userQuota.appCount < 0
}

export const hasEnoughExecuteCredits = (userQuota: ApiUserQuota | undefined): boolean => {
  if (!userQuota) {
    return false
  }
  return userQuota.executeCredits === 'unlimited' || userQuota.executeCredits > 0
}

export const hasInfiniteEditCredits = (userQuota: ApiUserQuota | undefined): boolean => {
  if (!userQuota) {
    return false
  }
  return userQuota.editCredits === 'unlimited'
}

export const hasInfiniteExecuteCredits = (userQuota: ApiUserQuota | undefined): boolean => {
  if (!userQuota) {
    return false
  }
  return userQuota.executeCredits === 'unlimited'
}

export const hasInfiniteAppCount = (userQuota: ApiUserQuota | undefined): boolean => {
  if (!userQuota) {
    return false
  }
  return userQuota.subscription.maxApps === 'unlimited'
}

export const nextTierName = (userQuota: ApiUserQuota | undefined): string => {
  if (!userQuota) {
    return 'Pro'
  }
  return userQuota.subscription.name === 'Free' ? 'Pro' : 'Launch'
}

export const nextTierId = (userQuota: ApiUserQuota | undefined): string => {
  if (!userQuota) {
    return 'pro'
  }
  return userQuota.subscription.name === 'Free' ? 'pro' : 'launch'
}
